import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col, Button } from '_zari/core'

import TiposDeDocumentoIdentificacionConstant from 'constants/tiposDeDocumentoIdentificacion'

import { KeyEventUtil } from 'utils'

import * as SociosCrud from 'services/socio.service'

const NumeroDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting, handleChange, setValues, values }) => {
  const __zariContext = React.useContext(ZariContext)

  const [opcionesBotonBuscar, setOpcionesBotonBuscar] = React.useState({
    buscando: false,
    texto: 'Buscar'
  })

  const clickBuscarSocioHandler = React.useCallback(() => {
    setOpcionesBotonBuscar({
      buscando: true,
      texto: 'Buscando...'
    })

    SociosCrud.getSocioViaSunat(values.numeroDocumento)
      .then(({ data }) => {
        values.direccion = data.direccion
        values.razonSocial = data.razonSocial
        values._idDepartamento = data._idDepartamento || ''
        values._idProvincia = data._idProvincia || ''
        values._idDistrito = data._idDistrito || ''
        values.padrones = data.padrones || []
        values.estado = data.estado || ''
        values.condicion = data.condicion || ''
        values.mostarComplementoInfo = true
        setValues(values)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        setOpcionesBotonBuscar({
          buscando: false,
          texto: 'Buscar'
        })
      })
  }, [__zariContext, values, setValues])

  const onKeyDown = React.useCallback(
    e => {
      KeyEventUtil.functionOnEnterOrTab(() => {
        if (values.tipoDocumento === TiposDeDocumentoIdentificacionConstant.RUC) {
          clickBuscarSocioHandler()
        }
      }, e)
    },
    [values.tipoDocumento, clickBuscarSocioHandler]
  )

  return (
    <Form.Group>
      <Form.Label text='NUM DOC' htmlFor='select-numeroDocumento' sm={2} alignRightAt='sm' />
      <Col sm={10}>
        {values.tipoDocumento === TiposDeDocumentoIdentificacionConstant.RUC ? (
          <Form.InputGroup>
            <Field name='numeroDocumento'>
              {({ field }) => (
                <Form.InputText
                  {...field}
                  disabled={fIsSubmitting || opcionesBotonBuscar.buscando}
                  isInvalid={iTouched && iError}
                  id='select-numeroDocumento'
                  onKeyDown={onKeyDown}
                  onChange={e => {
                    handleChange(e)
                    values.numeroDocumento = e.target.value
                    values.nombres = ''
                    values.razonSocial = ''
                    values.apellidos = ''
                    values.direccion = ''
                    values.email1 = ''
                    values.email2 = ''
                    values._idDepartamento = ''
                    values._idProvincia = ''
                    values._idDistrito = ''
                    setValues(values)
                  }}
                />
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button disabled={fIsSubmitting || opcionesBotonBuscar.buscando} onClick={clickBuscarSocioHandler}>
                {opcionesBotonBuscar.texto}
              </Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
        ) : (
          <Field name='numeroDocumento'>
            {({ field }) => (
              <Form.InputText
                {...field}
                disabled={fIsSubmitting}
                isInvalid={iTouched && iError}
                id='select-numeroDocumento'
                onChange={e => {
                  handleChange(e)
                  values.numeroDocumento = e.target.value
                  values.nombres = ''
                  values.razonSocial = ''
                  values.apellidos = ''
                  values.direccion = ''
                  values.email1 = ''
                  values.email2 = ''
                  values._idDepartamento = ''
                  values._idProvincia = ''
                  values._idDistrito = ''
                  setValues(values)
                }}
              />
            )}
          </Field>
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroDocumentoFormGroup)
